import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightRichText } from "../../../../modules/content/components/DaylightRichText/DaylightRichText";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { IWysiwygBlockProps } from "./WysiwygBlock.props";

export const WysiwygBlock = ({
  alignment,
  anchorId,
  buttons,
  content,
  description,
  eyebrow,
  heading,
  headingEffect,
  parentClass,
  spacing,
}: IWysiwygBlockProps) => {
  if (!content) return null;
  const hasIntro = Boolean(eyebrow || heading || description || buttons?.length);

  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10 md:gap-14">
        {hasIntro ? (
          <DaylightCommonContent
            alignment={alignment}
            buttons={buttons}
            className="daylight-work-surface rounded-[28px] p-7 lg:p-9 w-full max-w-none"
            description={description}
            eyebrow={eyebrow}
            heading={heading}
            headingEffect={headingEffect}
          />
        ) : null}
        <DaylightRichText
          className="w-full [&_h2]:mt-12 [&_h2]:font-daylight-display [&_h2]:text-3xl [&_h2]:font-bold [&_h2]:leading-tight [&_h2:first-child]:mt-0"
          content={content}
        />
      </div>
    </DaylightSection>
  );
};

WysiwygBlock.displayName = "Block::WysiwygBlock";
